<template functional>
    <a
        :href="props.link"
        target="_blank"
        class="subtle-link"
    >
        <span class="subtle-link__text">
            <slot />
        </span>
        <Icon
            size="sm"
            class="icon-arrow_right"
        />
    </a>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('SubtleLinkExternal', {
        functional: true,
        props: {
            link: {
                type: String,
                required: true,
            },
        },
    });
</script>
